// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3b_mj","left":"InfoRow_left__3nQ61"};